import { render, staticRenderFns } from "./SummaryCardwithSlot.vue?vue&type=template&id=95b63496&"
import script from "./SummaryCardwithSlot.vue?vue&type=script&lang=js&"
export * from "./SummaryCardwithSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports